import hyphenateNdc from 'utils/hyphenateNdc'

const HyphenatedNdc = ({ ndc }: { ndc: string | null }) => {
  return <>{hyphenateNdc(ndc ?? '')}</>
}
export default HyphenatedNdc
